/**
 * When a Cloudflare Realtime session error means the session itself is gone,
 * rather than some other transport failure.
 *
 * A session created at join time, before any track exists, has a
 * PeerConnection that never gets media; Cloudflare garbage-collects it and
 * every later `tracks/new` comes back as `410 session_error`. Recognizing
 * that text is what lets the transport rebuild the session instead of
 * demoting the whole room to mesh, and lets diagnostics label the failure
 * accurately instead of lumping every broker error under one bucket because
 * the broker's own error prefix happens to contain the word "session".
 */

const STALE_PATTERNS = [
  /session[_ ]?error/i,
  /session (appears to be )?disconnected/i,
  /session not found/i,
  /unknown session/i,
  /\b410\b/,
];

export function isStaleSessionError(error: unknown): boolean {
  const message =
    error instanceof Error
      ? error.message
      : typeof error === "string"
        ? error
        : "";
  if (!message) return false;
  return STALE_PATTERNS.some((pattern) => pattern.test(message));
}
